import { Button, ButtonGroup, useTheme } from '@mui/material'
import { FlexGrowCol, FlexGrowRow, useAsyncEffect } from '@xylabs/sdk-react'
import { XyoWorldMinterJsonObject } from '@xyo-network/sdk-xyoworld-js'
import { useState } from 'react'
import { Helmet } from 'react-helmet'
import JsonView from 'react-json-view'
import { Link } from 'react-router-dom'

import { useMinter } from '../../Contexts'
import WorldBasePage from '../WorldBasePage'

const PageBody: React.FC = () => {
  const { minter } = useMinter()
  const [staticData, setStaticData] = useState<XyoWorldMinterJsonObject>()
  const [refreshCount, setRefreshCount] = useState(0)
  const theme = useTheme()
  const jsonViewerTheme = theme?.palette.mode === 'dark' ? 'summerfruit' : 'summerfruit:inverted'

  useAsyncEffect(
    // eslint-disable-next-line react-hooks/exhaustive-deps
    async (isMounted) => {
      if (minter) {
        setStaticData(undefined)
        await minter.updateWithAllEvents()
        if (isMounted()) {
          setStaticData(minter.toJsonObject())
        }
      }
    },
    [minter, refreshCount],
  )

  const update = () => {
    setRefreshCount(refreshCount + 1)
  }

  const onRefreshClicked = async () => {
    await update()
  }

  const Buttons: React.FC = () => {
    return (
      <ButtonGroup color="primary" aria-label="outlined primary button group">
        <Button variant="outlined" component={Link} to={'/auctions/'}>
          Back
        </Button>
        <Button variant="outlined" onClick={onRefreshClicked}>
          Refresh
        </Button>
      </ButtonGroup>
    )
  }

  return (
    <FlexGrowRow paper marginY={1}>
      <FlexGrowCol paddingY={1}>
        <Buttons />
        <FlexGrowRow margin={2} padding={1} alignItems="flex-start" justifyContent="flex-start" busy={!staticData}>
          <JsonView style={{ padding: 8, width: '100%' }} theme={jsonViewerTheme} src={staticData ?? {}} />
        </FlexGrowRow>
        <Buttons />
      </FlexGrowCol>
    </FlexGrowRow>
  )
}

const ListJsonPage: React.FC = () => {
  return (
    <WorldBasePage container="xl">
      <Helmet title="Geotoken Details" />
      <PageBody />
    </WorldBasePage>
  )
}

export default ListJsonPage
